module.exports = __webpack_public_path__ + "static/media/portfolio (19).e8a17c51.jpg";